import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const CACHE_KEY = 'theme_colors';
const DEFAULT_COLORS = { primary: '#2563eb', secondary: '#1d4ed8' };

const ThemeContext = createContext(DEFAULT_COLORS);

export const useTheme = () => useContext(ThemeContext);

function getCachedColors() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.primary) return parsed;
    }
  } catch (_) {}
  return null;
}

export const ThemeProvider = ({ children }) => {
  const cached = getCachedColors();
  const [colors, setColors] = useState(cached || DEFAULT_COLORS);

  // Apply cached colors immediately so there's no flash on load
  useEffect(() => {
    const cached = getCachedColors();
    if (cached) applyColors(cached);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    axios.get('/api/organizations/my-organizations', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(({ data }) => {
      const orgUsers = Array.isArray(data) ? data : [];
      const primaryOrg = orgUsers.find(ou => ou?.is_primary) || orgUsers[0];
      const orgColors = primaryOrg?.Organization?.colors || primaryOrg?.colors;
      if (orgColors?.primary) {
        applyColors(orgColors);
        setColors(orgColors);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(orgColors)); } catch (_) {}
      }
    }).catch(() => {});
  }, []);

  return (
    <ThemeContext.Provider value={colors}>
      {children}
    </ThemeContext.Provider>
  );
};

export function applyColors(colors) {
  if (colors?.primary) {
    document.documentElement.style.setProperty('--theme-primary', colors.primary);
  }
  if (colors?.secondary) {
    document.documentElement.style.setProperty('--theme-secondary', colors.secondary);
  }
}
